import { cn } from '@/lib/utils';

/**
 * Renders one of the designer's SVGs as a CSS mask.
 *
 * The artwork ships with its colour baked in (`stroke="#445968"`,
 * `stroke="white"`, …), so an `<img>` can't be recoloured and can't follow
 * hover states. Masking uses only the SVG's shape and paints it with the
 * element's background colour, which `.sc-mask-icon` binds to `currentColor` —
 * so the icon takes the text colour of whatever contains it.
 *
 * Pass the size through `className` (e.g. `h-[18px] w-[18px]`).
 *
 * Decorative by default. Give a `label` when the icon is the only thing
 * conveying meaning — an icon-only button, for instance.
 */
export function MaskIcon({
  src,
  className,
  label,
}: {
  src: string;
  className?: string;
  label?: string;
}) {
  return (
    <span
      className={cn('sc-mask-icon', className)}
      style={{ maskImage: `url("${src}")`, WebkitMaskImage: `url("${src}")` }}
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
    />
  );
}
